import { createSelector } from '@reduxjs/toolkit';

export const selectLoading = (state) => state.credentials.loading;
export const selectUpdating = (state) => state.credentials.updating;
export const selectData = (state) => state.credentials.data;
export const selectError = (state) => state.credentials.error;

export const selectCredentialsByCategory = (category) =>
  createSelector([selectData], (data) => {
    return data?.find(({ brandCategory }) => brandCategory === category);
  });
